import { ItkDjangoApi } from '../django-api';

import { ItkDjangoUnderwritingApiV2 } from './itk-django-underwriting-api-v2';
import {
  FEX_TOOLKIT_CODE,
  TERM_TOOLKIT_CODE,
  MEDSUPP_TOOLKIT_CODE,
  DVH_TOOLKIT_CODE,
  HI_TOOLKIT_CODE,
  ToolkitCode,
  IUL_TOOLKIT_CODE,
} from '@itk/types';
export class ItkDjangoUnderwritingApi {
  fex: ItkDjangoUnderwritingApiV2;
  term: ItkDjangoUnderwritingApiV2;
  medsupp: ItkDjangoUnderwritingApiV2;
  dvh: ItkDjangoUnderwritingApiV2;
  hi: ItkDjangoUnderwritingApiV2;
  iul: ItkDjangoUnderwritingApiV2;

  constructor(api: ItkDjangoApi) {
    this.fex = new ItkDjangoUnderwritingApiV2(api, FEX_TOOLKIT_CODE);
    this.iul = new ItkDjangoUnderwritingApiV2(api, IUL_TOOLKIT_CODE);
    this.term = new ItkDjangoUnderwritingApiV2(api, TERM_TOOLKIT_CODE);
    this.medsupp = new ItkDjangoUnderwritingApiV2(api, MEDSUPP_TOOLKIT_CODE);
    this.dvh = new ItkDjangoUnderwritingApiV2(api, DVH_TOOLKIT_CODE);
    this.hi = new ItkDjangoUnderwritingApiV2(api, HI_TOOLKIT_CODE);
  }

  public endpoint(toolkit: ToolkitCode): ItkDjangoUnderwritingApiV2 {
    switch (toolkit) {
      case IUL_TOOLKIT_CODE: {
        return this.iul;
      }
      case FEX_TOOLKIT_CODE: {
        return this.fex;
      }
      case TERM_TOOLKIT_CODE: {
        return this.term;
      }
      case MEDSUPP_TOOLKIT_CODE: {
        return this.medsupp;
      }
      case DVH_TOOLKIT_CODE: {
        return this.dvh;
      }
      case HI_TOOLKIT_CODE: {
        return this.hi;
      }
    }
  }
}
